import Reflux from 'reflux';

let TeamActions = Reflux.createActions([
  'update',
  'updateError',
  'updateSuccess'
]);


export default TeamActions;



/** WEBPACK FOOTER **
 ** ./app/actions/teamActions.jsx
 **/